
export default {
  props: {
    gadgetVersion: 0,
    parentTitle: '',
    parentData: {},
    parentOptions: {},
  },
  data() {
    return {
      data: {},
      options: {},
    }
  },
  mounted() {
    /*
    this.addPlugin({
      afterDraw(chart) {
        console.log('chart:', chart)
        console.log('options', options)
        console.log('this', this)
        this.afterDrawX();
      }
    })
    */
    this.set();
    this.rend();
  },
  watch: {
    parentData() {
      this.set();
    },
    parentOptions() {
      this.set();
    },
    data() {
      this.rend();
    },
    options() {
      this.rend();
    }
  },
  methods: {
    // 呼び出し側で宣言した場合そちらが優先される。
    set() {
      this.check();
      this.data = this.parentData;
      this.options = this.parentOptions;
    },
    check() {
      // console.log('chart-id:', this.chartId);
    },
    rend() {
      // console.log('renderChart')
      this.set();
      this.renderChart(this.data, this.options);
      this.$emit('changeLegend', this.generateLegend());
    },
    afterDrawX() {
      // console.log('afterDraw2')
    },
  },
};
